<div class="dialog-container">
  <div class="dialog-header">
    <h2>{{ isEditMode ? 'Edit Questionnaire' : 'Add Questionnaire' }}</h2>
    <button mat-icon-button (click)="onCancel()" class="close-btn" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="questionareForm" (ngSubmit)="onSubmit()" class="dialog-form">

    <!-- ── Questionnaire metadata ── -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Category</mat-label>
      <input matInput formControlName="questionareCategory" placeholder="e.g. Electrical">
      <mat-error *ngIf="questionareForm.get('questionareCategory')?.hasError('required')">Category is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Subcategory</mat-label>
      <input matInput formControlName="subCategory" placeholder="e.g. Wiring">
      <mat-error *ngIf="questionareForm.get('subCategory')?.hasError('required')">Subcategory is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Name</mat-label>
      <input matInput formControlName="questionareName" placeholder="Questionnaire name">
      <mat-error *ngIf="questionareForm.get('questionareName')?.hasError('required')">Name is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="questionareDescription" rows="2" placeholder="Brief description"></textarea>
      <mat-error *ngIf="questionareForm.get('questionareDescription')?.hasError('required')">Description is required</mat-error>
    </mat-form-field>

    <!-- ── Questions section ── -->
    <div class="questions-section">

      <div class="questions-header">
        <span class="questions-label">
          <mat-icon class="qs-icon">help_outline</mat-icon>
          Questions
          <span class="questions-count" *ngIf="questions.length > 0">({{ questions.length }})</span>
        </span>
        <button type="button" mat-stroked-button class="add-q-btn"
                (click)="startAddQuestion()" *ngIf="!addingQuestion">
          <mat-icon>add</mat-icon> Add Question
        </button>
      </div>

      <!-- Existing questions list -->
      <div class="questions-list" *ngIf="questions.length > 0">
        <div class="question-row" *ngFor="let q of questions; let i = index">
          <div class="question-row-body">
            <span class="q-type-tag">{{ typeLabel(q.typeOfQuestion) }}</span>
            <div class="q-category" *ngIf="q.category">{{ q.category }}</div>
            <div class="q-desc">{{ q.description }}</div>
            <div class="q-answer" *ngIf="q.answer">
              <mat-icon class="q-answer-icon">check_circle_outline</mat-icon>
              {{ q.answer }}
            </div>
          </div>
          <button type="button" mat-icon-button class="q-remove-btn"
                  (click)="removeQuestion(i)" matTooltip="Remove">
            <mat-icon>remove_circle_outline</mat-icon>
          </button>
        </div>
      </div>

      <!-- No questions empty state -->
      <div class="no-questions" *ngIf="questions.length === 0 && !addingQuestion">
        No questions yet — click <strong>Add Question</strong> to begin.
      </div>

      <!-- Inline add-question form -->
      <div class="add-q-form" *ngIf="addingQuestion" [formGroup]="questionForm">

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Category</mat-label>
          <input matInput formControlName="category" placeholder="e.g. Safety">
          <mat-error>Category is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Question</mat-label>
          <textarea matInput formControlName="description" rows="2"
                    placeholder="Type the question here…"></textarea>
          <mat-error>Question text is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Type</mat-label>
          <mat-select formControlName="typeOfQuestion">
            <mat-option *ngFor="let t of questionTypes" [value]="t.value">{{ t.label }}</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- True/False answer -->
        <mat-form-field appearance="outline" class="full-width" *ngIf="currentType === TFQ.TrueFalse">
          <mat-label>Correct Answer</mat-label>
          <mat-select formControlName="answer">
            <mat-option value="True">True</mat-option>
            <mat-option value="False">False</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- All other answer types -->
        <mat-form-field appearance="outline" class="full-width" *ngIf="currentType !== TFQ.TrueFalse">
          <mat-label>Answer</mat-label>
          <input matInput formControlName="answer"
                 [placeholder]="currentType === TFQ.MultipleChoice ? 'Correct option text' :
                                currentType === TFQ.MultipleAnswer ? 'Comma-separated: Option A, Option C' :
                                'Expected answer'" />
          <mat-hint *ngIf="currentType === TFQ.MultipleAnswer">Separate multiple correct answers with commas</mat-hint>
        </mat-form-field>

        <div class="add-q-actions">
          <button type="button" mat-stroked-button (click)="cancelAddQuestion()">Cancel</button>
          <button type="button" mat-raised-button color="primary"
                  [disabled]="questionForm.invalid" (click)="addQuestion()">
            <mat-icon>add</mat-icon> Add
          </button>
        </div>
      </div>

    </div>

    <!-- ── Dialog save/cancel ── -->
    <div class="dialog-actions">
      <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" type="submit"
              [disabled]="questionareForm.invalid || saving">
        <mat-icon *ngIf="saving" class="spin">sync</mat-icon>
        {{ saving ? 'Saving...' : (isEditMode ? 'Save Changes' : 'Add Questionnaire') }}
      </button>
    </div>

  </form>
</div>
